import React from "react";
import { ClockIcon, FlameIcon, GlobeIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type OfferUrgencyProps = {
  dark?: boolean;
};
export function OfferUrgency({
  dark = false
}: OfferUrgencyProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    v: hours,
    l: "Hours"
  }, {
    v: minutes,
    l: "Min"
  }, {
    v: seconds,
    l: "Sec"
  }];
  return <div className="mx-auto mt-8 w-full max-w-md" data-id="element-30" data-mp="2mnmfxxdm20jy">
      <p className={`flex items-center justify-center gap-2 text-[13px] font-bold uppercase tracking-wider ${dark ? "text-goldsoft" : "text-navy"}`} data-id="element-31" data-mp="2moxglobres6u">
        <ClockIcon className="h-4 w-4" aria-hidden data-id="element-32" data-mp="2wjxuku0ob2hk" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" role="timer" aria-live="off" data-id="element-33" data-mp="31kvebb1c04l6">
        {units.map((u, i) => <React.Fragment key={u.l} data-id="element-34" data-mp="bwmaeoqqmqvw" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-35" data-mp="gtcstiq0lykh">
              <span className={`flex h-[72px] w-[78px] items-center justify-center rounded-xl font-serif text-[40px] font-bold tabular-nums ${dark ? "bg-white text-ink" : "bg-ink text-white"}`} data-id="element-36" data-mp="grrxhqvvmblk">
                {u.v}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/70" : "text-muted"}`} data-id="element-37" data-mp="3tbze7nrqoej3">{u.l}</span>
            </div>
            {i < 2 && <span className={`pt-4 font-serif text-3xl font-bold ${dark ? "text-white" : "text-ink"}`} data-id="element-38" data-mp="3ofhbsujvss9x">:</span>}
          </React.Fragment>)}
      </div>

      <div className={`mt-6 rounded-2xl border p-4 ${dark ? "border-white/15 bg-white/5" : "border-red-200 bg-white"}`} data-id="element-39" data-mp="3emjo8a018d4g">
        <div className="flex items-center justify-between gap-3" data-id="element-40" data-mp="39oi4rnyp2bsg">
          <p className={`flex items-center gap-1.5 text-[13px] font-extrabold uppercase tracking-wide ${dark ? "text-red-300" : "text-red-600"}`} data-id="element-41" data-mp="35noj718q592q">
            <FlameIcon className="h-4 w-4" aria-hidden data-id="element-42" data-mp="30pemunb9k2fj" />
            Limited launch price
          </p>
          <span className={`text-[13px] font-extrabold ${dark ? "text-white" : "text-ink"}`} data-id="element-43" data-mp="2vqtm8ms3ngqk">91% claimed</span>
        </div>
        <div className={`mt-3 h-4 w-full overflow-hidden rounded-full ${dark ? "bg-white/10" : "bg-red-100"}`} role="progressbar" aria-valuenow={91} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-44" data-mp="2r0hfnglkjddv">
          <div className="bar-stripes h-full rounded-full bg-red-600" style={{
          width: "91%"
        }} data-id="element-45" data-mp="2h2tmuw7iwfyc" />
        </div>
        <p className={`mt-3 text-center text-[15px] font-semibold ${dark ? "text-white" : "text-ink"}`} data-id="element-46" data-mp="34ruxmq3tw36s">
          Only <span className={`font-extrabold ${dark ? "text-red-300" : "text-red-600"}`} data-id="element-47" data-mp="39po1hchnsl3w">9 spots</span> remaining at the promotional price.
        </p>
      </div>

      <p className={`mt-4 flex items-center justify-center gap-2 text-center text-[13px] ${dark ? "text-white/70" : "text-muted"}`} data-id="element-48" data-mp="2zzus8i4zoi2t">
        <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden data-id="element-49" data-mp="3nonnsdhp8nww" />
        Currency conversion is handled automatically according to your country.
      </p>
    </div>;
}